import { useTranslation } from 'react-i18next'

import type { TemplateCategory } from '@/api/types'
import { Button } from '@/shared/ui/button'
import type { TemplateFilter } from '../gallery'

export function CategoryPills({
  categories,
  archived,
  value,
  onChange,
}: {
  categories: readonly TemplateCategory[]
  /** Whether to offer the archived templates' pill. */
  archived: boolean
  value: TemplateFilter
  onChange: (value: TemplateFilter) => void
}) {
  const { t } = useTranslation()
  const pills: { id: TemplateFilter; label: string }[] = [
    { id: 'all', label: t('templates.all') },
    { id: 'company', label: t('templates.company') },
    ...categories,
    ...(archived ? [{ id: 'archived', label: t('templates.archived') }] : []),
  ]

  return (
    <div
      role="group"
      aria-label={t('templates.filter')}
      className="flex flex-wrap gap-1.5"
    >
      {pills.map((pill) => {
        const pressed = pill.id === value
        return (
          <Button
            key={pill.id}
            type="button"
            size="sm"
            variant={pressed ? 'default' : 'ghost'}
            aria-pressed={pressed}
            className="h-8 rounded-full"
            onClick={() => onChange(pill.id)}
          >
            {pill.label}
          </Button>
        )
      })}
    </div>
  )
}
